// Generated by `scripts/export-frontend-api.sh`. Do not edit manually.
//
// The chat endpoint's request limits, from the constants at the top of
// `src/bin/company_router/chat.rs`. Import these rather than writing a
// number down: a UI limit that drifts above the server's turns into a
// rejection the user can do nothing about.

/** Characters of transcript the endpoint accepts, summed over all messages. */
export const CHAT_MAX_TOTAL_CONTENT_CHARS = 100000;

/** Messages the endpoint accepts in one transcript. */
export const CHAT_MAX_MESSAGES = 60;
